import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { Button } from '@material-ui/core';
import CopyToClipboard from 'react-copy-to-clipboard';

import { closeModal } from 'features/utilsSlice';
import toast from 'utils/toast.jsx';
import ShareIcon from 'public/icons/share-white.svg';
import CopyToClipboardIcon from 'public/icons/copy-to-clipboard-white.svg';
import useModalData from 'hooks/useModalData';
import useModalOpen from 'hooks/useModalOpen';
import TransitionDialog from './TransitionDialog';
import IconMainContainer from 'components/IconMainContainer';

const btnHeight = { height: 40 };

const useStyles = makeStyles(theme => ({
  paper: {
    height: 'fit-content',
    width: 200,
    marginBottom: 'auto',
    top: '20%',
    borderRadius: 10,
    padding: '15px 10px',
  },

  paperFullScreenDialog: {
    width: '100%',
  },
}));

const UrlDialog = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const open = useModalOpen('Url Dialog');
  const { url } = useModalData('Url Dialog');

  const handleClose = () => dispatch(closeModal('Url Dialog'));

  const handleCopy = text => {
    toast('success', `Successfully copied the ${text}!`, {
      icon: <IconMainContainer src="/icons/notifications/thumb-up.svg" alt="Thumb Up" />,
    });

    handleClose();
  };

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      paperProps={{ className: classes.paper }}
      dialogStyles={classes.paperFullScreenDialog}
      direction="up"
      desktopDirection="up"
      noCloseIcon
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        <CopyToClipboard text={url}>
          <Button
            style={btnHeight}
            variant="contained"
            color="primary"
            onClick={() => handleCopy('url')}
            endIcon={<ShareIcon />}
          >
            Copy
          </Button>
        </CopyToClipboard>

        <a href={url} target="_blank" rel="noreferrer">
          <Button
            style={btnHeight}
            onClick={handleClose}
            variant="contained"
            color="primary"
            endIcon={<CopyToClipboardIcon />}
            fullWidth
          >
            Open
          </Button>
        </a>
      </div>
    </TransitionDialog>
  );
};

export default UrlDialog;
